function formatThaiPhoneNumber(input: string): string {
	const numericOnly = input.replace(/\D/g, '')

	if (numericOnly.startsWith('0')) {
		return `${numericOnly.substring(0, 3)}-${numericOnly.substring(3, 6)}-${numericOnly.substring(
			6
		)}`
	} else {
		return `${numericOnly.substring(0, 2)}-${numericOnly.substring(2, 5)}-${numericOnly.substring(
			5
		)}`
	}
}

export default formatThaiPhoneNumber
